import React from "react";
import { POLICY_OUTCOMES } from "../../data/content";

const toneMap = {
  green: "border-signal-green/30 text-signal-green",
  cyan: "border-primary/30 text-primary",
  amber: "border-signal-amber/30 text-signal-amber",
  red: "border-signal-red/30 text-signal-red",
};

export default function PolicyOutcomes() {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {POLICY_OUTCOMES.map((o) => (
        <div key={o.name} className="rounded-xl border border-white/10 bg-navy-900/60 p-5">
          <span className={`inline-flex items-center rounded-md border px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ${toneMap[o.tone]}`}>
            {o.name}
          </span>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{o.desc}</p>
        </div>
      ))}
    </div>
  );
}
